import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ENV_OPTIONS } from "@up/shared/injection-tokens";

export interface ReviewsTrackersResponse{
    totalReviews: number;
    rating: number;
    location: any;
}

@Injectable({ providedIn: 'root' })
export class ReviewTrackersService {
    readonly API_KEY = 'review-trackers';
    readonly API_URL = `${this.environmentOptions.apiUrl}/${this.API_KEY}`;

    constructor(
        @Inject(ENV_OPTIONS) private environmentOptions: any,
        private http: HttpClient
    ) {}

    public reviewStatsForReceipt(
        merchantId: string,
        sources: string[] = ['']
    ): Observable<ReviewsTrackersResponse> {
        return this.http
            .get<ReviewsTrackersResponse>(
                this.API_URL+
                `/reviewStatsForReceipt/${merchantId}?sources=${sources}`
            )
            .pipe(
                map((data) => data),
                catchError(this.handleError)
            );
    }

    protected handleError(res: HttpErrorResponse | any) {
        console.error(res.error || res.body.error);
        return observableThrowError(res.error || 'Server error');
    }
}
